export class PodtResultContent {}
